import React from 'react';
import { useCallContext } from '~/context/CallContext';
import ActiveCallModal from '~/call/ActiveCallModal';
import CallDeviceModal from '~/call/CallDeviceModal';

const GlobalCallManager = () => {
  const {
    callStatus,
    callData,
    callDuration,
    isActiveCallVisible,
    localStream,
    remoteStream,
    closeAllAndHangup,
    setMicMuted,
    callerUsername,
    micUnavailable,
    speakerUnavailable,
    reportRemotePlaybackFailure,
    reportSpeakerRecovered,
    registerRemotePlaybackRecover,
  } = useCallContext();

  return (
    <>
      <CallDeviceModal />

      {isActiveCallVisible && (
        <ActiveCallModal
          callStatus={callStatus}
          callDuration={callDuration}
          localStream={localStream}
          remoteStream={remoteStream}
          data={callData}
          callerUsername={callerUsername}
          micUnavailable={micUnavailable}
          speakerUnavailable={speakerUnavailable}
          onRemotePlaybackError={reportRemotePlaybackFailure}
          onSpeakerRecovered={reportSpeakerRecovered}
          registerRemotePlaybackRecover={registerRemotePlaybackRecover}
          onHangup={closeAllAndHangup}
          onToggleMute={setMicMuted}
        />
      )}
    </>
  );
};

export default GlobalCallManager;
